import LogoMark from "./LogoMark";
import { brand } from "../data/site";

const cols = [
    {
        title: "Explore",
        links: [
            { label: "Legacy", href: "#legacy" },
            { label: "Projects", href: "#projects" },
            { label: "Under Construction", href: "#ongoing" },
            { label: "Journey", href: "#journey" },
            { label: "Contact", href: "#contact" },
        ],
    },
    {
        title: "Services",
        links: [
            { label: "Apartments", href: "#services" },
            { label: "Luxury Villas", href: "#services" },
            { label: "Commercial", href: "#services" },
            { label: "Property Development", href: "#services" },
        ],
    },
    {
        title: "Elsewhere",
        links: [
            { label: "Instagram", href: brand.social.instagram },
            { label: "Facebook", href: brand.social.facebook },
            { label: "LinkedIn", href: brand.social.linkedin },
        ],
    },
];

export default function Footer() {
    return (
        <footer className="relative bg-[#0b0b0b] pt-24 md:pt-32 pb-10 px-6 md:px-10 border-t border-[rgba(212,175,55,0.2)]" data-testid="site-footer">
            <div className="mx-auto max-w-[1440px]">
                {/* Colossal wordmark */}
                <div className="mb-16 md:mb-20">
                    <div className="text-[10px] uppercase tracking-[0.4em] text-[#C89B3C] mb-6">
                        Let&apos;s begin
                    </div>
                    <a
                        href="#contact"
                        className="group inline-flex items-baseline gap-6 font-display font-light tracking-tighter text-white leading-[0.9] text-5xl sm:text-6xl md:text-7xl lg:text-8xl hover:text-[#E2C56D] transition-colors"
                        data-testid="footer-cta-word"
                    >
                        Build with us
                        <span className="text-[#C89B3C] text-3xl md:text-5xl">→</span>
                    </a>
                </div>

                <div className="grid grid-cols-12 gap-10 border-t border-[rgba(212,175,55,0.2)] pt-14">
                    <div className="col-span-12 lg:col-span-5">
                        <div className="flex items-center gap-4">
                            <LogoMark size={54} animate={false} />
                            <div>
                                <div className="font-display text-white tracking-[0.14em] text-lg uppercase">
                                    BRA Sheriff
                                </div>
                                <div className="text-[10px] uppercase tracking-[0.35em] text-[#bebebe]">
                                    Builders &amp; Developers
                                </div>
                            </div>
                        </div>

                        <address className="not-italic mt-6 text-[#bebebe] text-sm font-light leading-relaxed max-w-sm">
                            {brand.address.line1}
                            <br />
                            {brand.address.line2}
                            <br />
                            {brand.address.line3}
                        </address>

                        <div className="mt-6 text-sm text-[#bebebe] font-light">
                            <a
                                href={`tel:${brand.phoneRaw}`}
                                className="block text-white hover:text-[#E2C56D]"
                            >
                                {brand.phone}
                            </a>
                            <a
                                href={`mailto:${brand.email}`}
                                className="block hover:text-[#E2C56D]"
                            >
                                {brand.email}
                            </a>
                        </div>
                    </div>

                    {cols.map((c) => (
                        <div
                            key={c.title}
                            className="col-span-6 md:col-span-4 lg:col-span-2"
                        >
                            <div className="text-[10px] uppercase tracking-[0.4em] text-[#C89B3C] mb-5">
                                {c.title}
                            </div>
                            <ul className="space-y-3">
                                {c.links.map((l) => (
                                    <li key={l.label}>
                                        <a
                                            href={l.href}
                                            className="text-sm text-white/85 hover:text-[#E2C56D] transition-colors"
                                        >
                                            {l.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}

                    <div className="col-span-12 lg:col-span-1 flex lg:justify-end items-start">
                        <a
                            href="#top"
                            className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-white hover:text-[#E2C56D]"
                            data-testid="back-to-top"
                        >
                            Top ↑
                        </a>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-[rgba(212,175,55,0.15)] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] uppercase tracking-[0.3em] text-[#7a7a7a]">
                    <span>© {new Date().getFullYear()} BRA Sheriff Builders &amp; Developers. All rights reserved.</span>
                    <span>Made in Bangalore · Est. 1984</span>
                </div>
            </div>
        </footer>
    );
}
